import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "./firebase-config";

/**
 * Writes a single audit entry to admin_logs.
 * Never throws — logging must never block the main operation.
 */
export async function logAction(action, target, targetId = null) {
  try {
    await addDoc(collection(db, "admin_logs"), {
      action,
      target: String(target).slice(0, 200),
      targetId,
      admin: auth.currentUser?.email || "unknown",
      timestamp: serverTimestamp(),
    });
  } catch (_) {}
}
